import {createContext} from 'react'

import type {UpmPlant, UpmPlantsContextValue} from './types'

export const UpmPlantContext = createContext<UpmPlant | undefined>(undefined)
export const UpmPlantsContext = createContext<UpmPlantsContextValue | undefined>(undefined)
